"use client";

export { trpc, useTRPC, useTRPCClient } from "@/os";
